/* eslint-disable */
import { Box } from '@mui/system';
import React, { useState, useContext, useEffect, useRef } from 'react';
import Drawer from '@mui/material/Drawer';
import { AppBar, Backdrop, Button, Checkbox, CircularProgress, Dialog, FormControlLabel, Grid, IconButton, InputBase, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useUserStore } from '../../store/user';
import http from '../../api/axiosInstance';
import { useSnackbar } from 'notistack';
import { ReactComponent as ArrowIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import Toolbar from '@mui/material/Toolbar';
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as SreachIcon } from "../../Assets/svg/SreachIcon.svg";
import Slide from '@mui/material/Slide';
// import LoginVideo from '../../Assets/video/Flydownloader.mp4'
import { useSearchPropStore } from '../../store/searchProperty';
import { ReactComponent as LockIcon } from "../../Assets/svg/LockIcon.svg";
import { ReactComponent as MobileGrayIcon } from "../../Assets/svg/MobileGrayIcon.svg";
import { SearchCities, setLocationIdCookie, setTokenCookie, setUserCookie } from '../../Components/PublicFunctions';

import { ReactComponent as BackArrow } from "../../Assets/svg/BackArrow.svg";
import { ReactComponent as ArrowRightIconTransparent } from "../../Assets/svg/ArrowRightIconTransparent.svg";
import Cookies from 'js-cookie'
import {useMarket} from "../../context/MarketContext";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function Login(props) {
    const [loginOpen, setLoginOpen] = React.useState(false);
    const [passwordModal, setPasswordModal] = React.useState(false);
    const [isFirstStep, setIsFirstStep] = React.useState(true);
    const [registerStep1, setRegisterStep1] = React.useState(false);
    const [registerStep2, setRegisterStep2] = React.useState(false);
    const [registerStep3, setRegisterStep3] = React.useState(false);
    const [registerMobile, setRegisterMobile] = React.useState("");
    const [otpNumber, setOtpNumber] = React.useState("");
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [openProvinceModal, setOpenProvinceModal] = React.useState(false);
    const [cityProvince, setCityProvince] = React.useState([]);
    const [provinceSelected, setProvinceSelected] = React.useState(false);
    const [province, setProvince] = React.useState(null);
    const [city, setCity] = React.useState(null);
    const [cityTitle, setCityTitle] = React.useState(null);
    const [registerPassword, setRegisterPassword] = React.useState("");
    const [confRegisterPassword, setConfRegisterPassword] = React.useState("");
    const [loginMobile, setChangeLoginMobile] = React.useState("");
    const [loginPassword, setChangeLoginPassword] = React.useState("");
    const [formId, setFormId] = React.useState("");
    const [capchaLoading, setCapchaLoading] = React.useState(false);
    const [getCapchModal, setGetCapchModal] = React.useState(false);
    const [capchaCode, setCapchaCode] = React.useState("");
    const [captchaKey, setCaptchaKey] = React.useState(0);
    const [selectUser, setSelectUser] = React.useState(false);
    const [afterSelectPassModal, setAfterSelectPassModal] = React.useState(false);
    const [userInfoToSelect, setUserInfoToSelect] = React.useState({});
    const [selectedUser, setSelectedUser] = React.useState({});
    const [showPass, setShowPass] = React.useState(false);
    const [userSelectedPass, setUserSlectedPass] = React.useState("");

    const userInfo = useUserStore((state) => state.userInfo)
    const setUserInfo = useUserStore((state) => state.setUserInfo)
    const accessToken = useUserStore((state) => state.accessToken)
    const setToken = useUserStore((state) => state.setToken)
    const setLocationName = useUserStore((state) => state.setLocationName)
    const setLocationId = useUserStore((state) => state.setLocationId)

    const navigate = useNavigate();
    const market = useMarket();

    const { enqueueSnackbar } = useSnackbar();


    const changeLoginMobile = (e) => {
        setChangeLoginMobile(e.target.value)
    }

    const changeLoginPassword = (e) => {
        setChangeLoginPassword(e.target.value)
    }

    const getProvinces = () => {
        if (!localStorage.getItem('provinces')) {
            http.post('/locations/provinces/list')
                .then(response => {
                    setCityProvince(response.data.result.Provinces)
                    localStorage.setItem('provinces', JSON.stringify(response.data.result.Provinces))
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
        } else {
            console.log(JSON.parse(localStorage.getItem('provinces')))
            setCityProvince(JSON.parse(localStorage.getItem('provinces')))
        }
    }

    useEffect(() => {
        getProvinces()


        setCapchaLoading(true)
        try {
            http({
                url: "/get-form-id",
                method: "GET",

            }).then((res) => {
                console.log(res);
                setFormId(res.data.result.form_id)
                setCapchaLoading(false)
            });
        } catch (e) {
            console.error(e);
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            setCapchaLoading(false)
        }

        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            console.log("This is an iOS device.");
            const variant = 'defualt'
            enqueueSnackbar('در گوشی آیفون ابتدا گزینه Share را از نوار پایین صفحه مرورگر در موبایل خود انتخاب کنید، سپس Add to Home Screen را بزنید و در آخر گزینه Add را انتخاب کنید. با این روش آیکون اپلیکیشن به لیست اپ های نصب شده اضافه می شود', { variant, autoHideDuration: 6000, hideIconVariant: false });
        } else {
            console.log("This is not an iOS device!");
        }
    }, [])

    const setSearchData = useSearchPropStore((state) => state.setSearchData)

    const resetCapcha = async () => {
        setCapchaLoading(true)
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: `/reset-captcha/${formId}`,
                method: "GET",

            }).then((res) => {
                console.log(res);
                setCaptchaKey(captchaKey => captchaKey + 1)
                setCapchaLoading(false)
            });
        } catch (e) {
            console.error(e);
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            setCapchaLoading(false)
        }
    }

    const openLogin = async () => {
        setLoginOpen(true)
        setIsFirstStep(false)


    }
    const closeLogin = () => {
        setLoginOpen(false)
        setIsFirstStep(true)
    }

    const openPassword = () => {
        setPasswordModal(true)
        setIsFirstStep(false)
    }
    const closeCapchaModal = () => {
        setGetCapchModal(false)
        setIsFirstStep(true)
    }

    const openGetCapchModal = () => {
        setGetCapchModal(true)
        setIsFirstStep(false)
    }
    const closePassword = () => {
        setPasswordModal(false)
        setIsFirstStep(true)
    }

    const handleSelectUserOpen = async () => {
        setSelectUser(true)
        setIsFirstStep(false)
    }

    const handleSelectUserClose = () => {
        setSelectUser(false)
        setIsFirstStep(true)
    }

    const handleAfterSelectPassModalOpen = async (user, agency = null) => {
        if (user) {
            setSelectedUser({
                "AgencyId": "",
                "Password": "",
                "UserId": user.id,
                "UserName": user.username,
                "UserPost": user.post
            })
            setRegisterMobile("")
        }
        if (agency) {
            console.log(agency.AgencyMobile, "agency.AgencyMobile")
            setRegisterMobile(agency.AgencyMobile)
        }
        setAfterSelectPassModal(true)
        setIsFirstStep(false)
    }

    const handleAfterSelectPassModalClose = () => {
        setAfterSelectPassModal(false)
        setIsFirstStep(true)
    }

    const openRegisterStep1 = async () => {
        setRegisterStep1(true)
        setRegisterStep2(false)
        setIsFirstStep(false)

        // try {
        //     await http({
        //         // url of the api endpoint (can be changed)
        //         url: "/get-form-id",
        //         method: "GET",

        //     }).then((res) => {

        //         console.log(res);



        //     });
        // } catch (e) {
        //     console.error(e);
        //     if (e.response.data.result == false) {
        //         const variant = 'error'
        //         enqueueSnackbar(e.response.data.message, { variant });
        //     }

        // }

    }
    const closeRegisterStep1 = () => {
        setRegisterStep1(false)
        setIsFirstStep(true)
    }

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const openRegisterStep2 = async () => {
        setRegisterStep2(true)
        closeRegisterStep1()
        setIsFirstStep(false)


    }

    const sendCapcha = async () => {
        if (registerMobile != "") {
            if (capchaCode != "") {
                handleToggleBackdrop()
                try {
                    await http({
                        // url of the api endpoint (can be changed)
                        url: "/authenticate/send/otp/to/mobile/via/sms",
                        method: "POST",
                        data: {
                            "AgencyMobile": registerMobile,
                            "FormId": formId,
                            "CaptchaCode": capchaCode
                        }
                    }).then((res) => {

                        console.log(res);
                        if (res.data.result) {
                            const variant = 'success'
                            enqueueSnackbar('کد تایید با موفقیت ارسال شد.', { variant });
                            closeCapchaModal()
                            openRegisterStep2()
                        } else {
                            // openGetCapchModal()
                            if (res.data.logical_code == 6) {
                                const variant = 'error'
                                enqueueSnackbar("شما قبلا درخواست کد داده اید لطفا صبر کنید.", { variant });
                            } else {
                                const variant = 'error'
                                enqueueSnackbar(res.data.message, { variant });
                                resetCapcha()
                            }

                        }
                        handleCloseBackdrop()

                    });
                } catch (e) {
                    console.error(e);
                    if (e.response.data.result == false) {
                        const variant = 'error'
                        enqueueSnackbar(e.response.data.message, { variant });
                    }
                    handleCloseBackdrop()
                }
            } else {
                const variant = 'error'
                enqueueSnackbar("کد امنیتی را وارد کنید.", { variant });
            }
        }
        else {
            console.log("registerMobile", registerMobile)
            const variant = 'error'
            enqueueSnackbar('شماره همراه را وارد کنید.', { variant });
        }
    }

    const forgetPassSendCapcha = async () => {
        if (registerMobile != "") {
            if (capchaCode != "") {
                handleToggleBackdrop()
                try {
                    await http({
                        // url of the api endpoint (can be changed)
                        url: "/authenticate/send/otp/to/mobile/via/sms",
                        method: "POST",
                        data: {
                            "AgencyMobile": registerMobile,
                            "FormId": formId,
                            "CaptchaCode": capchaCode
                        }
                    }).then((res) => {

                        console.log(res);
                        if (res.data.result) {
                            const variant = 'success'
                            enqueueSnackbar('کد تایید با موفقیت ارسال شد.', { variant });
                            closeForgetPass1()
                            openForgetPass2()
                        } else {
                            if (res.data.logical_code == 6) {
                                const variant = 'error'
                                enqueueSnackbar("شما قبلا درخواست کد داده اید لطفا صبر کنید.", { variant });
                            } else {
                                const variant = 'error'
                                enqueueSnackbar(res.data.message, { variant });
                                resetCapcha()
                            }
                        }
                        handleCloseBackdrop()

                    });
                } catch (e) {
                    console.error(e);
                    if (e.response.data.result == false) {
                        const variant = 'error'
                        enqueueSnackbar(e.response.data.message, { variant });
                    }
                    handleCloseBackdrop()
                }
            } else {
                const variant = 'error'
                enqueueSnackbar("کد امنیتی را وارد کنید.", { variant });
            }
        }
        else {
            console.log("registerMobile", registerMobile)
            const variant = 'error'
            enqueueSnackbar('شماره همراه را وارد کنید.', { variant });
        }
    }

    const closeRegisterStep2 = () => {
        setRegisterStep2(false)
        setIsFirstStep(true)
    }

    const registerMobileHandle = (e) => {
        setRegisterMobile(e.target.value)
    }

    const handleOtpNumber = (e) => {
        setOtpNumber(e.target.value)
    }


    const openRegisterStep3 = () => {
        setRegisterStep1(false)
        setRegisterStep2(false)
        setRegisterStep3(true)
        setIsFirstStep(false)
    }
    const closeRegisterStep3 = () => {
        setRegisterStep3(false)
        setIsFirstStep(true)
    }

    const sendOtpHandle = async () => {
        if (otpNumber != "" || window.otpNumber) {
            handleToggleBackdrop()
            try {
                await http({
                    // url of the api endpoint (can be changed)
                    url: "/authenticate/check/otp",
                    method: "POST",
                    data: {
                        "AgencyMobile": registerMobile,
                        "OTP": otpNumber || window?.otpNumber,
                    }
                }).then((res) => {

                    console.log(res);
                    if (res.data.result) {
                        openRegisterStep3()
                    } else {

                        const variant = 'error'
                        enqueueSnackbar(res.data.message, { variant });
                    }
                    handleCloseBackdrop()

                });
            } catch (e) {
                console.error(e);

                if (e.response.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleCloseBackdrop()
            }
        }
        else {
            const variant = 'error'
            enqueueSnackbar('کد تایید را وارد کنید.', { variant });
             
        }
    }


    const handleClickOpenProvinceModal = () => {
        setOpenProvinceModal(true);
    };

    const handleProvinceClose = () => {
        setOpenProvinceModal(false);
    };

    const handleProvinceSelected = async (e) => {
        setProvince(e.target.value)
        handleToggleBackdrop()
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/locations/province/cities/list",
                method: "POST",
                data: {
                    "ProvinceId": e.target.value,
                }
            }).then((res) => {

                setCityProvince(res.data.result.Cities)
                setProvinceSelected(true)
                handleCloseBackdrop()

            });
        } catch (e) {
            console.error(e);

            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            handleCloseBackdrop()
        }
    };

    const handleSetCity = (e) => {
        console.log("city")
        setCity(e.target.value)
        setCityTitle(cityProvince.filter(item => item.Id == e.target.value)[0].FarsiName)
        console.log(cityTitle)
    }
    const handleBackToProvince = (e) => {
        console.log("back")
        setCity(null)
        setProvince(null)
        setCityTitle(null)
        setProvinceSelected(false)
        getProvinces()
    }

    const handleSearch = async (e) => {
        if (provinceSelected) {

            handleToggleBackdrop()
            try {
                await http({

                    url: "/locations/province/cities/list",
                    method: "POST",
                    data: {
                        "ProvinceId": province ? province : '',
                        "Name": e.target.value
                    }
                }).then((res) => {
                    setCityProvince(res.data.result.Cities)
                    setProvinceSelected(true)
                    handleCloseBackdrop()
                });
            } catch (e) {
                console.error(e);

                if (e.response.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleCloseBackdrop()
            }



        } else {
            if (e.target.value != "") {
                console.log("SearchCities", SearchCities(e.target.value, cityProvince))
                setCityProvince(SearchCities(e.target.value, cityProvince))
            } else {
                getProvinces()
            }
        }

    }

    const registerHandle = async () => {
        if (registerPassword != "" && city) {
            if (registerPassword == confRegisterPassword) {
                handleToggleBackdrop()
                try {
                    await http({
                        // url of the api endpoint (can be changed)
                        url: "/authenticate/register/with/otp",
                        method: "POST",
                        data: {
                            "AgencyMobile": registerMobile,
                            "LocationId": city,
                            "Secret": registerPassword,
                            // "Username": "mehdi",
                            // "AgencyName": "بیرجند سیتی",
                            // "FullName": "مهدی گندمی",
                            // "Latitude": "32",
                            // "Longitude": "59",
                            // "PhysicalAddress": "بیرجند",
                            // "Area": "وحدت",
                            // "AgentCode": "",
                            "Version": "4.2.2",
                            // "MacAddress": "",
                            "OTP": otpNumber,
                            "AppType": "Website"
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.result) {

                            if(market === "direct"){
                                let string_data = JSON.stringify({
                                    access_token: res.data.result.AccessToken,
                                    agency_id: res.data.result.Agency.Id,
                                    user_id: res.data.result.Agency.UserId
                                });
                                window.location.href = "myapp://data/?data=" + string_data;
                            }

                            localStorage.setItem('token', res.data.result.AccessToken)
                            setUserCookie(res.data.result.AccessToken)
                            localStorage.setItem('agency', JSON.stringify(res.data.result.Agency))
                            setUserCookie(res.data.result.Agency)
                            localStorage.setItem('locationId', res.data.result.Agency.LocationId)
                            setLocationIdCookie(res.data.result.Agency.LocationId)
                     
                            setUserInfo(res.data.result.Agency)
                            setToken(res.data.result.AccessToken)
                            setSearchData({ name: 'AgencyId', value: res.data.result.Agency.Id })
                            setSearchData({ name: 'LocationId', value: res.data.result.Agency.LocationId })
                            navigate("/");
                        }
                    });
                } catch (e) {
                    console.error(e);

                    if (e.response.data.result == false) {
                        const variant = 'error'
                        enqueueSnackbar(e.response.data.message, { variant });
                    }
                    handleCloseBackdrop()
                }
            } else {
                const variant = 'error'
                enqueueSnackbar("کلمه عبور و تایید کلمه عبور مطابقت ندارد", { variant });
            }
        }
        else {
            const variant = 'error'
            enqueueSnackbar("فیلد هارا پر کنید.", { variant });
        }
    }

    const loginHandle = async () => {
        console.log("registerMobile", registerMobile)
        console.log("loginPassword", loginPassword)
        if (loginPassword != "" && registerMobile != "") {
            handleToggleBackdrop()
            try {
                await http({
                    // url of the api endpoint (can be changed)
                    url: "/authenticate/login/with/password",
                    method: "POST",
                    data: {
                        "AgencyMobile": registerMobile,
                        "Secret": loginPassword,
                        "Version": "4.2.2",
                        "AppType": "Website"
                    }
                }).then((res) => {
                    console.log(res)
                    if (res.data.result) {

                        if(market === "direct"){
                            let string_data = JSON.stringify({
                                access_token: res.data.result.AccessToken,
                                agency_id: res.data.result.Agency.Id,
                                user_id: res.data.result.Agency.UserId
                            });
                            window.location.href = "myapp://data/?data=" + string_data;
                        }

                        console.log(res)
                        localStorage.setItem('token', res.data.result.AccessToken)
                        setTokenCookie(res.data.result.AccessToken)
                        localStorage.setItem('agency', JSON.stringify(res.data.result.Agency))
                        setUserCookie(res.data.result.Agency)
                        localStorage.setItem('locationId', res.data.result.Agency.LocationId)
                        localStorage.setItem('locationName', res.data.result.Agency.LocationName)

                        setLocationIdCookie(response.data.result.Agency.LocationId)
                    Cookies.set('locationName', response.data.result.Agency.LocationName)

                        setLocationName(Cookies.get('locationName'))
                        setLocationId(Cookies.get('locationId'))
                        setUserInfo(res.data.result.Agency)
                        setToken(res.data.result.AccessToken)
                        setSearchData({ name: 'AgencyId', value: res.data.result.Agency.Id })
                        setSearchData({ name: 'LocationId', value: res.data.result.Agency.LocationId })
                        navigate("/");
                    }
                });
            } catch (e) {
                console.error(e);

                if (e.response.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleCloseBackdrop()
            }
        }
        else {
            const variant = 'error'
            enqueueSnackbar("فیلد هارا پر کنید.", { variant });
        }
    }

    const checkExist = async () => {

        if (registerMobile != "") {

            handleToggleBackdrop()
            try {
                const res = await http({
                    // url of the api endpoint (can be changed)
                    url: "/authenticate/exist/mobile",
                    method: "POST",
                    data: {
                        "AgencyMobile": registerMobile,

                    }
                })
                console.log(res)
                if (res.data.result.Exist) {
                    if (res.data.result.AccountStatus == "1") {
                        try {
                            const usersRes = await http({
                                url: "/users/get-all-users",
                                method: "POST",
                                data: {
                                    AgencyMobile: registerMobile
                                }
                            })
                            console.log(usersRes)
                            closeLogin()
                            if (usersRes.data.result.Users.length) {
                                setUserInfoToSelect(usersRes.data.result)
                                handleSelectUserOpen()
                            } else {
                                openPassword()
                            }

                        } catch (e) {
                            console.error(e);
                        }
                    } else {
                        const variant = 'error'
                        enqueueSnackbar("دسترسی به اکانت شما توسط مدیر غیرفعال شده است", { variant });
                    }
                }
                else {
                    closeLogin()
                    setRegisterMobile(registerMobile)
                    console.log(registerMobile)
                    openGetCapchModal()
                    // openRegisterStep2()
                }



                handleCloseBackdrop()

            } catch (e) {
                console.error(e);

                if (e.response.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleCloseBackdrop()
            }

        } else {
            const variant = 'error'
            enqueueSnackbar("موبایل خود را وارد کنید.", { variant });
        }
    }


    const handleSelectUserToLogin = async () => {
        handleToggleBackdrop()
        if (loginPassword != "") {
            try {
                const response = await http({
                    url: "/users/check-password",
                    method: "POST",
                    data: {
                        "AgencyId": userInfoToSelect?.Agency?.AgencyId,
                        "Password": loginPassword,
                        "UserId": selectedUser.UserId
                    }
                })
                console.log(response)
                if (response.data.result && response.data.result.AccessToken) {
                    localStorage.setItem('token', response.data.result.AccessToken)
                    if(market === "direct"){
                        let string_data = JSON.stringify({
                            access_token: response.data.result.AccessToken,
                            agency_id: userInfoToSelect?.Agency?.AgencyId,
                            user_id: selectedUser.UserId
                        });
                        window.location.href = "myapp://data/?data=" + string_data;
                    }
                    setTokenCookie(response.data.result.AccessToken)
                    localStorage.setItem('agency', JSON.stringify(response.data.result.Agency))
                    setUserCookie(response.data.result.Agency)
                    localStorage.setItem('locationId', response.data.result.Agency.LocationId)
                    localStorage.setItem('locationName', response.data.result.Agency.LocationName)

                    setLocationIdCookie(response.data.result.Agency.LocationId)
                    Cookies.set('locationName', response.data.result.Agency.LocationName)

                    setLocationName(Cookies.get('locationName'))
                    setLocationId(Cookies.get('locationId'))
                    setUserInfo(response.data.result.Agency)
                    setToken(response.data.result.AccessToken)
                    setSearchData({ name: 'AgencyId', value: response.data.result.Agency.Id })
                    setSearchData({ name: 'LocationId', value: response.data.result.Agency.LocationId })

                    if (response.data.result.User && Object.keys(response.data.result.User).length){
                        localStorage.setItem('subUserInfo', JSON.stringify(response.data.result.User))
                        Cookies.set('subUserInfo', JSON.stringify(response.data.result.User))
                    }

                    navigate("/");
                } else {
                    const variant = 'error'
                    enqueueSnackbar("پسورد وارد شده اشتباه است.", { variant });
                }
            } catch (e) {
                console.error(e);
            }
        } else {
            const variant = 'error'
            enqueueSnackbar("پسورد را وارد کنید.", { variant });
        }
        handleCloseBackdrop()

    }

    /// forget password 
    const [ForgetPass1, setForgetPass1] = React.useState(false);
    const [ForgetPass2, setForgetPass2] = React.useState(false);
    const [ForgetPass3, setForgetPass3] = React.useState(false);

    const [ForgetPassMobile, setForgetPassMobile] = React.useState("");
    const [ForgetOtp, setForgetOtp] = React.useState("");
    const [forgetPassword, setForgetPassword] = React.useState("");
    const [confForgetPassword, setConfForgetPassword] = React.useState("");

    const openForgetPass1 = () => {
        setForgetPass1(true)
        setForgetPass2(false)
        // closePassword()
        // setIsFirstStep(false)
        // openForgetPass1()
        // closeLogin()
        handleAfterSelectPassModalClose()
        handleSelectUserClose()
        setCapchaLoading(true)
        try {
            http({
                url: "/get-form-id",
                method: "GET",

            }).then((res) => {
                console.log(res);
                setFormId(res.data.result.form_id)
                setCapchaLoading(false)
            });
        } catch (e) {
            console.error(e);
            if (e.response.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            setCapchaLoading(false)
        }
    }
    const closeForgetPass1 = () => {
        setForgetPass1(false)
        setIsFirstStep(true)
    }

    const openForgetPass2 = async () => {

        if (registerMobile != "") {
            setForgetPass2(true)
            closePassword()
            closeForgetPass1()
            setIsFirstStep(false)
            // handleToggleBackdrop()
            //     try {
            //         await http({
            //             // url of the api endpoint (can be changed)
            //             url: "/authenticate/send/otp/to/mobile/via/sms",
            //             method: "POST",
            //             data: {
            //                 "AgencyMobile": registerMobile
            //             }
            //         }).then((res) => {

            //             console.log(res);
            //             if (res.data.ok) {
            //                 const variant = 'success'
            //                 enqueueSnackbar('کد تایید با موفقیت ارسال شد.', { variant });
            //                 setForgetPass2(true)
            //                 closePassword()
            //                 closeForgetPass1()
            //                 setIsFirstStep(false)
            //             }
            //             handleCloseBackdrop()

            //         });
            //     } catch (e) {
            //         console.error(e);
            //         if (e.response.data.result == false) {
            //             const variant = 'error'
            //             enqueueSnackbar(e.response.data.message, { variant });
            //         }
            //         handleCloseBackdrop()
            //     }
        }
        // else {
        //     const variant = 'error'
        //     enqueueSnackbar('شماره همراه را وارد کنید.', { variant });
        // }

    }
    const closeForgetPass2 = () => {
        setForgetPass2(false)
        setIsFirstStep(true)
    }

    const ForgetPassMobileHandle = (e) => {
        setForgetPassMobile(e.target.value)
    }

    const handleForgetOtp = (e) => {
        setForgetOtp(e.target.value)
        console.log("🚀 ~ handleForgetOtp ~ e.target.value:", e.target.value)

    }

    const openForgetPass3 = () => {
        setForgetPass1(false)
        setForgetPass2(false)
        setForgetPass3(true)
        setIsFirstStep(false)
    }
    const closeForgetPass3 = () => {
        setForgetPass3(false)
        setIsFirstStep(true)
    }

    const ForgetSendOtpHandle = async () => {
        if (ForgetOtp != "" || window.otpNumber) {
            handleToggleBackdrop()
            try {
                await http({
                    // url of the api endpoint (can be changed)
                    url: "/authenticate/check/otp",
                    method: "POST",
                    data: {
                        "AgencyMobile": registerMobile,
                        "OTP": ForgetOtp || window.otpNumber,
                    }
                }).then((res) => {

                    console.log(res);
                    if (res.data.result) {
                        openForgetPass3()
                    } else {
                        const variant = 'error'
                        enqueueSnackbar(res.data.message, { variant });
                    }
                    handleCloseBackdrop()

                });
            } catch (e) {
                console.error(e);

                if (e.response.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
                handleCloseBackdrop()
            }
        }
        else {
            const variant = 'error'
            enqueueSnackbar('کد تایید را وارد کنید.', { variant });
        }
    }


    const handleForgetPassword = async () => {
        if (forgetPassword != "") {
            if (forgetPassword == confForgetPassword) {
                handleToggleBackdrop()
                try {
                    await http({
                        // url of the api endpoint (can be changed)
                        url: "/authenticate/change/password",
                        method: "POST",
                        data: {
                            "AgencyMobile": registerMobile,
                            "Password": forgetPassword,
                            "ConfirmPassword": confForgetPassword,
                            "Version": "4.2.2",
                            "OTP": ForgetOtp,
                            "AppType": "Website"
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.ok && res.data.result) {
                            const variant = 'success'
                            enqueueSnackbar('پسورد با موفقیت تغییر کرد.', { variant });
                            closeForgetPass3()
                            setIsFirstStep(true)
                            handleCloseBackdrop()
                        }
                        else{
                            const variant = 'error'
                            enqueueSnackbar('پسورد تغییر نکرد.', { variant });
                        }
                    });
                } catch (e) {
                    console.error(e);

                    if (e.response.data.result == false) {
                        const variant = 'error'
                        enqueueSnackbar(e.response.data.message, { variant });
                        closeForgetPass3()
                        setIsFirstStep(true)
                        handleCloseBackdrop()
                    }

                }
            } else {
                const variant = 'error'
                enqueueSnackbar("کلمه عبور و تایید کلمه عبور مطابقت ندارد", { variant });

            }
        }
        else {
            const variant = 'error'
            enqueueSnackbar("فیلد هارا پر کنید.", { variant });
        }
    }

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ position: "relative", width: '100%', height: '100vh' }} className="login-box">
                {/* <video id="loginVideo" loop autoPlay muted playsInline controlsList="nodownload">
                    <source src={LoginVideo} type="video/mp4" />
                    <source src={LoginVideo} type="video/ogg" />
                    Your browser does not support HTML5 video.
                </video> */}

                {isFirstStep && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={isFirstStep}
                    onClose={closeLogin}

                >
                    <Box className="dialog-container" sx={{ color: '#8F8F8F', display: 'flex', alignItems: 'center', p: 3, gap: '15px', flexDirection: 'column' }}>

                        <Box className='form-control' sx={{ pt: 3 }}>
                            <Box sx={{ textAlign: "right", fontSize: "15px" }}>
                                نرم افزار مدیریت ارتباط با مشتری
                                و فایلینگ املاک پایش
                            </Box>
                            <Box sx={{ mt: 3 }}>
                                <label htmlFor='mobile'>
                                    شماره موبایل خود را وارد کنید
                                </label>
                                {/* <Box>
                                <InputBase id="mobile" className='input-outline-white' sx={{ px: 1, py: '5px', color: '#fff' }} type='tel' value={registerMobile} onChange={registerMobileHandle} />
                            </Box> */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, }} className="gray-input">
                                    {registerMobile.length > 0 && <IconButton onClick={() => setRegisterMobile("")}>
                                        <CloseIcon />
                                    </IconButton>}
                                    <Box className="flex-1 text-center">
                                        <InputBase inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} type='tel' value={registerMobile} onChange={registerMobileHandle} />
                                    </Box>
                                    <IconButton>
                                        <MobileGrayIcon />
                                    </IconButton>
                                </Box>
                                <Button className='green-btn' onClick={checkExist} sx={{ display: 'block', width: '100%', height: '47px', mt: 2, mb: 4 }}>ادامه</Button>
                                <a href="https://app.payesh.me/%d8%aa%d9%88%d8%a7%d9%81%d9%82-%d9%86%d8%a7%d9%85%d9%87-%d9%88-%d8%aa%d8%b9%d9%87%d8%af%d8%a7%d8%aa-%d9%be%d8%a7%db%8c%d8%b4/" target='_blank'   > توافق نامه و تعهدات پایش</a>
                            </Box>
                        </Box>
                        {/* <Box className='form-control'>
                            <label htmlFor='password'>
                                کلمه عبور
                            </label>
                            <InputBase id="password" className='input-outline-white' sx={{ px: 1, py: '5px', color: '#fff' }} type='password' value={loginPassword} onChange={changeLoginPassword} />
                        </Box> */}
                        {/* <Link className='text-green'>کلمه عبور خود را فراموش کرده ام</Link> */}

                    </Box>
                </Dialog>}

                {getCapchModal && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={getCapchModal}
                    onClose={closeCapchaModal}

                >
                    <Box className="dialog-container" sx={{ color: '#8F8F8F', display: 'flex', alignItems: 'center', p: 4, gap: '15px', flexDirection: 'column' }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Box></Box>
                                <IconButton onClick={() => {
                                    closeCapchaModal()                                     
                                    setIsFirstStep(true)
                                }}>
                                    <BackArrow />
                                </IconButton>
                            </Box>
                        <Box className='form-control' sx={{ width: "100%" }}>
                            <label htmlFor='mobile'>
                                تلفن همراه
                            </label>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, }} className="gray-input">
                                <Box className="flex-1 text-center">
                                    <InputBase id="mobile" inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} type='tel' value={registerMobile} onChange={registerMobileHandle} />
                                </Box>
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: "center", mt: 2, flexDirection: "column" }}>
                                <Box sx={{ display: 'flex', justifyContent: "center", gap: "5px" }}>
                                    <img src={`https://api.iranamlaak.net/show-captcha/${formId}.jpg?${captchaKey}`} />
                                    <IconButton onClick={resetCapcha}>
                                        <img src="/assets/img/refreshIcon.png" width="20" />
                                    </IconButton>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }} className="gray-input">
                                    <Box className="flex-1 text-center">
                                        <InputBase id="capcha" placeholder='کد امنیتی' value={capchaCode} onChange={(e) => setCapchaCode(e.target.value)} />
                                    </Box>
                                </Box>
                            </Box>
                            <Button className='green-btn' onClick={sendCapcha} sx={{ display: 'block', width: '100%', height: '47px', mt: 2, mb: 4 }}>ادامه</Button>

                        </Box>
                        {/* <Box className='form-control'>
                            <label htmlFor='password'>
                                کلمه عبور
                            </label>
                            <InputBase id="password" className='input-outline-white' sx={{ px: 1, py: '5px', color: '#fff' }} type='password' value={loginPassword} onChange={changeLoginPassword} />
                        </Box> */}
                        {/* <Link className='text-green'>کلمه عبور خود را فراموش کرده ام</Link> */}
                    </Box>
                </Dialog>}

                {passwordModal && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={passwordModal}
                    onClose={closePassword}

                >
                    <Box className="dialog-container" sx={{ color: '#fff', display: 'flex', alignItems: 'center', p: 4, gap: '15px', flexDirection: 'column' }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <Box></Box>
                            <IconButton onClick={() => {
                                closePassword()
                                setIsFirstStep(true)
                            }}>
                                <BackArrow />
                            </IconButton>
                        </Box>
                        <Box className='form-control' sx={{ width: "100%" }}>
                            <label htmlFor='password' style={{ color: "#8F8F8F" }}>
                                کلمه عبور خود را وارد کنید.
                            </label>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }} className="gray-input">
                                <Box className="flex-1 text-center">
                                    <InputBase id="password" type='password' value={loginPassword} onChange={changeLoginPassword} />
                                </Box>
                                <IconButton>
                                    <LockIcon />
                                </IconButton>
                            </Box>
                            <Box>
                                <FormControlLabel className='green-check f-16' sx={{ mr: 0, color: "#8F8F8F" }} control={<Checkbox />} label="کلمه عبور ذخیره شود" />
                            </Box>
                            <Typography variant='span' sx={{ cursor: "pointer", }} className='text-green' onClick={openForgetPass1}>کلمه عبور خود را فراموش کرده ام</Typography>
                            <Button className='green-btn' onClick={loginHandle} sx={{ display: 'block', width: '100%', height: '47px', mt: 2, mb: 4 }}>ورود</Button>
                        </Box>

                    </Box>
                </Dialog>}

                {selectUser && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={selectUser}
                    onClose={handleSelectUserClose}

                >
                    <Box sx={{ position: "relative", width: '100%', height: '100vh' }} className="login-box">
                        <Box sx={{ p: "25px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Box></Box>
                                <IconButton onClick={() => {
                                    handleSelectUserClose()
                                    setIsFirstStep(true)

                                }}>
                                    <BackArrow />
                                </IconButton>
                            </Box>
                            <Box className="top-settings-header">
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Box className="avatar-container">
                                        {userInfoToSelect?.Agency.Avatar && userInfoToSelect?.Agency.Avatar != "" ? <img src={userInfoToSelect.Agency.Avatar} /> : <img src='/assets/img/User-avatar.svg.png' />}
                                    </Box>
                                    <Box>
                                        <Typography component='p' sx={{ mb: 1, fontSize: '14px' }}>
                                            {userInfoToSelect?.Agency?.AgencyName}
                                        </Typography>
                                        <Typography component='p' sx={{ fontSize: '14px' }}>
                                            {userInfoToSelect?.Agency?.AgencyMobile}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box>

                                </Box>
                            </Box>
                            <Box sx={{ mt: 4, display: "flex", flexDirection: "column", gap: "10px" }}>
                                {/* <Button className="select-user-item" onClick={() => handleAfterSelectPassModalOpen(null, userInfoToSelect.Agency)}>
                                    <Box sx={{ flex: 1, display: "flex", gap: "10px" }}>
                                        {userInfoToSelect?.Agency.Avatar && userInfoToSelect?.Agency.Avatar != "" ? <img src={userInfoToSelect.Agency.Avatar} /> : <img src='/assets/img/User-avatar.svg.png' />}
                                        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                            <Box sx={{ fontSize: "12px" }}>
                                                {userInfoToSelect?.Agency?.AgencyName}
                                            </Box>
                                            <Box sx={{ fontSize: "10px" }}>
                                                {userInfoToSelect?.Agency?.AgencyMobile}
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box sx={{ pl: 3, display: "inline-flex", alignItems: "center" }}>
                                        <ArrowRightIconTransparent style={{ stroke: "#fff", transform: "rotate(180deg)" }} />
                                    </Box>
                                </Button> */}
                                {userInfoToSelect.Users && userInfoToSelect.Users.length && userInfoToSelect.Users.map((item, index) => {
                                    return <Button className="select-user-item" key={index} onClick={() => handleAfterSelectPassModalOpen(item)}>
                                        <Box sx={{ flex: 1, display: "flex", gap: "10px" }}>
                                            <img src='/assets/img/User-avatar.svg.png' />
                                            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                                <Box sx={{ fontSize: "12px" }}>{item.username}</Box>
                                                <Box sx={{ fontSize: "10px" }}>{item.post}</Box>
                                            </Box>
                                        </Box>
                                        <Box sx={{ pl: 3, display: "inline-flex", alignItems: "center" }}>
                                            <ArrowRightIconTransparent style={{ stroke: "#fff", transform: "rotate(180deg)" }} />
                                        </Box>
                                    </Button>
                                })}
                            </Box>

                        </Box>
                    </Box>
                </Dialog>}

                {afterSelectPassModal && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={afterSelectPassModal}
                    onClose={handleAfterSelectPassModalClose}
                >
                    <Box sx={{ position: "relative", width: '100%', height: '100vh' }} className="login-box">
                        <Box sx={{ p: "25px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Box></Box>
                                <IconButton onClick={() => {
                                    handleAfterSelectPassModalClose()
                                    handleSelectUserOpen()
                                }}>
                                    <BackArrow />
                                </IconButton>
                            </Box>
                            <Box className="top-settings-header">
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Box className="avatar-container">
                                        <img src='/assets/img/User-avatar.svg.png' />
                                    </Box>
                                    <Box>
                                        <Typography component='p' sx={{ mb: 1, fontSize: '14px' }}>
                                            {selectedUser.UserName ? selectedUser.UserName : userInfoToSelect?.Agency?.AgencyName}
                                        </Typography>
                                        <Typography component='p' sx={{ fontSize: '14px' }}>
                                            {selectedUser?.UserPost}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box>

                                </Box>
                            </Box>
                            <Box sx={{ mt: 4, display: "flex", flexDirection: "column", gap: "10px" }}>
                                <label htmlFor='password' style={{ color: "#8F8F8F" }}>
                                    کلمه عبور خود را وارد کنید.
                                </label>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }} className="gray-input">
                                    <Box className="flex-1 text-center">
                                        <InputBase id="password" type={showPass ? "text" : 'password'} value={loginPassword} onChange={e => setChangeLoginPassword(e.target.value)} />
                                    </Box>
                                    <IconButton onClick={() => setShowPass(!showPass)}>
                                        <img src={showPass ? '/assets/img/hide-img.png' : '/assets/img/show-img.png'} />
                                    </IconButton>
                                </Box>
                                <Box>
                                    <FormControlLabel className='green-check f-16' sx={{ mr: 0, color: "#8F8F8F" }} control={<Checkbox />} label="کلمه عبور ذخیره شود" />

                                </Box>
                                <Box>
                                    {/* <Link className='text-green' onClick={openForgetPass1}>کلمه عبور خود را فراموش کرده ام</Link> */}
                                    <Typography variant='span' sx={{ cursor: "pointer", }} className='text-green' onClick={openForgetPass1}>کلمه عبور خود را فراموش کرده ام</Typography>

                                    <Button className='green-btn' onClick={registerMobile != "" ? loginHandle : handleSelectUserToLogin} sx={{ display: 'block', width: '100%', height: '47px', mt: 2, mb: 4 }}>ورود</Button>
                                </Box>
                            </Box>

                        </Box>
                    </Box>
                </Dialog>}

                {registerStep1 && <Drawer
                    anchor="bottom"
                    open={registerStep1}
                    onClose={closeRegisterStep1}
                    className="drawer-container"
                >
                    <Box className="dialog-container" sx={{ color: '#fff', display: 'flex', alignItems: 'center', p: 3, gap: '15px', flexDirection: 'column' }}>
                        
                        <Box className='form-control'>
                            <label htmlFor='regMobile'>
                                شماره موبایل خود را وارد کنید
                            </label>
                            <InputBase id="regMobile" inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} type='tel' className='input-outline-white' sx={{ px: 1, py: '5px', color: '#fff' }} value={registerMobile} onChange={registerMobileHandle} />
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: "center", mt: 2, flexDirection: "column" }}>
                            <Box sx={{ display: 'flex', justifyContent: "center", gap: "5px" }}>
                                <img src={`https://api.iranamlaak.net/show-captcha/${formId}.jpg?${captchaKey}`} />
                                <IconButton onClick={resetCapcha}>
                                    <img src="/assets/img/refreshIcon.png" width="20" />
                                </IconButton>
                            </Box>
                            <InputBase id="capcha" className='input-outline-white' sx={{ px: 1, py: '5px', color: '#fff', mt: 1 }} placeholder='کد امنیتی' value={capchaCode} onChange={(e) => setCapchaCode(e.target.value)} />
                        </Box>

                        <Button className='btn-white-outline' onClick={openRegisterStep2} sx={{ display: 'block', width: '175px', height: '47px', bgcolor: '#fff!important', color: '#707070!important', mt: 1 }}>ادامه</Button>
                    </Box>
                </Drawer>}

                {registerStep2 && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={registerStep2}
                    onClose={closeRegisterStep2}

                >
                    <Box className="dialog-container" sx={{ color: '#8F8F8F', display: 'flex', alignItems: 'center', p: 3, gap: '15px', flexDirection: 'column' }}>
                        <Box className='form-control' sx={{ maxWidth: '300px', pt: 3 }}>
                            <label htmlFor='regMobile'>
                                کد شش رقمی که به شماره {registerMobile} ارسال شده است را وارد کنید.
                                <Link className='text-green f-12' onClick={() => {
                                    closeRegisterStep2()
                                    setIsFirstStep(true)
                                }}> ویرایش شماره</Link>
                            </label>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2 }} className="gray-input">
                                <Box className="flex-1 text-center">

                                    <InputBase id="regMobile" inputProps={{ pattern: "\d*", maxlength: "6" }} type='tel' value={otpNumber} onChange={handleOtpNumber} />

                                </Box>
                            </Box>
                            {/* <Link className='text-green'>ثبت نام با ایمیل</Link> */}
                            <Button className='green-btn' onClick={sendOtpHandle} sx={{ display: 'block', width: '100%', height: '47px', mt: 2, mb: 4 }}>ادامه</Button>
                        </Box>

                    </Box>
                </Dialog>}

                {registerStep3 && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={registerStep3}
                    onClose={closeRegisterStep3}

                >
                    <Box className="dialog-container" sx={{ color: '#8F8F8F', display: 'flex', alignItems: 'center', py: 3, px: 8, gap: '15px', flexDirection: 'column' }}>
                        <Box className='form-control' sx={{ width: "100%" }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2 }} className="gray-input">
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', px: 2, py: '10px', color: '#8F8F8F', width: "100%" }} onClick={handleClickOpenProvinceModal}>
                                    {!cityTitle || cityTitle == "" ? "انتخاب شهر" : cityTitle}
                                    <ArrowIcon className='rotate-180-minus' />
                                </Box>
                            </Box>
                            <Box className='form-control' sx={{ width: '100%' }}>
                                <label htmlFor='password'>
                                    کلمه عبور
                                </label>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2 }} className="gray-input">
                                    <Box className="flex-1 text-center">
                                        <InputBase id="password" sx={{ flex: "1" }} onChange={e => setRegisterPassword(e.target.value)} value={registerPassword} type='password' />
                                    </Box>
                                    <IconButton>
                                        <LockIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Box className='form-control' sx={{ width: '100%' }}>
                                <label htmlFor='password'>
                                    تایید کلمه عبور
                                </label>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2 }} className="gray-input">
                                    <Box className="flex-1 text-center">
                                        <InputBase id="password" sx={{ flex: "1" }} onChange={e => setConfRegisterPassword(e.target.value)} value={confRegisterPassword} type='password' />
                                    </Box>
                                    <IconButton>
                                        <LockIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Button className='green-btn' sx={{ display: 'block', width: '100%', height: '47px', mt: 2, mb: 4 }} onClick={registerHandle}>ثبت نام</Button>
                        </Box>
                    </Box>
                </Dialog>}

                {openProvinceModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openProvinceModal}
                    onClose={handleProvinceClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>
                            {provinceSelected ? <Button className='green-btn f-11' onClick={handleBackToProvince}>
                                استان ها
                            </Button> : ''}
                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                انتخاب شهر
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleProvinceClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>

                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                        <Box className="inputs-container" sx={{ display: "flex", width: 'auto', alignItems: "center", border: '0px', bgcolor: '#EEEBEB' }}>
                            <InputBase placeholder='جستجو کنید...' className='flex-1' onChange={handleSearch} />
                            <IconButton>
                                <SreachIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ px: 1, mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                            <Grid container spacing={3}>
                                {cityProvince && cityProvince.length ? cityProvince.map((item, index) => (
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                        <input type="radio" name='cityProvince' value={item.Id} id={`cityProvince${index}`} className="d-none floorCheck" onChange={!provinceSelected ? handleProvinceSelected : handleSetCity} checked={!provinceSelected ? province == item.Id : city == item.Id} />
                                        <label htmlFor={`cityProvince${index}`} className='inputs-container floorLabel w-100'>
                                            <span className="flex-1">{item.FarsiName}</span>
                                        </label>
                                    </Grid>
                                )) : <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box>}
                            </Grid>
                        </Box>
                    </Box>
                    <Button
                        onClick={handleProvinceClose} autoFocus
                        className='green-btn' sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>انتخاب</Button>
                </Dialog>}

                {ForgetPass1 && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={ForgetPass1}
                    onClose={closeForgetPass1}

                >
                    <Box sx={{ position: "relative", width: '100%', height: '100vh' }} className="login-box">
                        {/* <Box className="dialog-container login-box" sx={{ color: '#8F8F8F', display: 'flex', alignItems: 'center', p: 4, gap: '15px', flexDirection: 'column' }}> */}
                        <Box sx={{ p: "25px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Box></Box>
                                <IconButton onClick={() => {
                                    closeForgetPass1()
                                    closePassword()
                                    setIsFirstStep(true)
                                }}>
                                    <BackArrow />
                                </IconButton>
                            </Box>
                            <Box className='form-control' >
                                <label htmlFor='regMobile'>
                                    شماره موبایل خود را وارد کنید
                                </label>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2 }} className="gray-input">
                                    <Box className="flex-1 text-center">
                                        <InputBase inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} type='tel' value={registerMobile} onChange={registerMobileHandle} />
                                    </Box>
                                    <IconButton>
                                        <MobileGrayIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Box className='form-control' sx={{ width: "100%" }}>
                                <Box sx={{ display: 'flex', justifyContent: "center", mt: 2, flexDirection: "column" }}>
                                    <Box sx={{ display: 'flex', justifyContent: "center", gap: "5px" }}>
                                        <img src={`https://api.iranamlaak.net/show-captcha/${formId}.jpg?${captchaKey}`} />
                                        <IconButton onClick={resetCapcha}>
                                            <img src="/assets/img/refreshIcon.png" width="20" />
                                        </IconButton>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2 }} className="gray-input">
                                        <Box className="flex-1 text-center">
                                            <InputBase id="capcha" placeholder='کد امنیتی' value={capchaCode} onChange={(e) => setCapchaCode(e.target.value)} />
                                        </Box>

                                    </Box>
                                </Box>
                            </Box>

                            <Button onClick={forgetPassSendCapcha} className='green-btn' sx={{ display: 'block', width: '100%', height: '47px', mt: 2, mb: 4 }}>ادامه</Button>
                        </Box>
                    </Box>
                </Dialog>}

                {ForgetPass2 && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={ForgetPass2}
                    onClose={closeForgetPass2}

                >
                    <Box className="dialog-container" sx={{ color: '#8F8F8F', display: 'flex', alignItems: 'center', p: 4, gap: '15px', flexDirection: 'column' }}>
                        <Box className='form-control' sx={{ width: "100%", pt: 3 }}>
                            <label htmlFor='regMobile'>
                                کد شش رقمی که به شماره {registerMobile} ارسال شده است را وارد کنید.
                                <Link className='text-green f-12' onClick={openForgetPass1}> ویرایش شماره</Link>
                            </label>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2 }} className="gray-input">
                                <Box className="flex-1 text-center">

                                    <InputBase id="regMobile" inputProps={{ pattern: "\d*", maxlength: "6" }} type='tel' value={ForgetOtp} onChange={handleForgetOtp} />


                                </Box>
                            </Box>

                            <Button onClick={ForgetSendOtpHandle} className='green-btn' sx={{ display: 'block', width: '100%', height: '47px', mt: 2, mb: 4 }}>ادامه</Button>

                        </Box>
                        {/* <Link className='text-green'>ثبت نام با ایمیل</Link> */}
                    </Box>
                </Dialog>}

                {ForgetPass3 && <Dialog className="dialog-box login-dialog"
                    fullScreen
                    open={ForgetPass3}
                    onClose={closeForgetPass3}

                >
                    <Box className="dialog-container" sx={{ color: '#8F8F8F', display: 'flex', alignItems: 'center', py: 3, px: 8, gap: '15px', flexDirection: 'column' }}>
                        <Box>
                            <p>کلمه عبوری که وارد می کنید تا زمانی معتبر است که شما وارد نسخه ویندوزی پایش نشده اید پس از ورود به نسخه ویندوزی باید با همان کلمه عبور نسخه ویندوزی در این بخش وارد شوید.</p>
                        </Box>
                        <Box className='form-control' sx={{ width: '100%' }}>
                            <label htmlFor='password'>
                                کلمه عبور
                            </label>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2 }} className="gray-input">
                                <Box className="flex-1 text-center">
                                    <InputBase id="password" onChange={e => setForgetPassword(e.target.value)} value={forgetPassword} type='password' />
                                </Box>
                                <IconButton>
                                    <LockIcon />
                                </IconButton>
                            </Box>
                        </Box>
                        <Box className='form-control' sx={{ width: '100%' }}>
                            <label htmlFor='password'>
                                تایید کلمه عبور
                            </label>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2 }} className="gray-input">
                                <Box className="flex-1 text-center">
                                    <InputBase id="password" onChange={e => setConfForgetPassword(e.target.value)} value={confForgetPassword} type='password' />
                                </Box>
                                <IconButton>
                                    <LockIcon />
                                </IconButton>
                            </Box>
                            <Button className='green-btn' sx={{ display: 'block', width: '100%', height: '47px', mt: 2, mb: 4 }} onClick={handleForgetPassword}>ثبت</Button>

                        </Box>
                    </Box>
                </Dialog >}
            </Box >
        </>
    );
}

export default Login;